import { chart_black, chart_blue, chart_red } from './ChartColors'

export const AppointmentsChartOptions = (
  appointmentsData: Highcharts.SeriesBarOptions['data'],
  MOTData: Highcharts.SeriesBarOptions['data'],
  tyrechangeData: Highcharts.SeriesBarOptions['data'] = [],
  height: string,
  legend: boolean
): Highcharts.Options => ({
  chart: {
    type: 'column',
    height
  },
  title: {
    text: ''
  },
  legend: {
    enabled: legend
  },
  exporting: {
    enabled: true
  },
  yAxis: {
    title: {
      text: '',
      align: 'middle'
    }
  },
  xAxis: {
    categories: appointmentsData!.map((row: any) => row.name)
  },
  series: [
    {
      name: '',
      color: chart_red,
      data: appointmentsData
    },
    {
      name: '',
      color: chart_blue,
      data: MOTData
    },
    {
      name: '',
      color: chart_black,
      data: tyrechangeData
    }
  ] as Array<Highcharts.SeriesBarOptions>
})
